// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__dwpjU","container":"Checkbox_container__AfoqF","error":"Checkbox_error__RgxDV"};